import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MyNavLink from "../MyNavLink";
import { LanguageContext } from "@/data/LanguageProvider";
import style from "./style.less";

function getTabClass(linkPath, locationPath) {
  return linkPath === locationPath ? `${style.tab_item} ${style.tab_active}` : style.tab_item;
}

function getTabNavClass(linkPath, locationPath, itemName) {
  let activeClassName = "tab_" + itemName + "_active";
  let className = "tab_" + itemName;
  return linkPath === locationPath
    ? `${style.tab_item} ${style[activeClassName]}`
    : `${style.tab_item} ${style[className]}`;
}

const BottomNav = (props) => {
  const { getLanguage, langText } = useContext(LanguageContext);
  let location = useLocation();
  console.log("location.pathname:", location.pathname);
  return (
    <div class={style.container}>
      <MyNavLink to="/home">
        <div class={getTabNavClass("/home", location.pathname, "home")} />
      </MyNavLink>
      <MyNavLink to="/deposit" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/deposit", location.pathname, "deposit")} />
      </MyNavLink>
      <MyNavLink to="/MakeMoney" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/MakeMoney", location.pathname, "MakeMoney")} />
      </MyNavLink>
      <MyNavLink to="/withdraw" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/withdraw", location.pathname, "withdraw")} />
      </MyNavLink>
      <MyNavLink to="/profile" style={{ zIndex: "2" }}>
        <div class={getTabNavClass("/profile", location.pathname, "profile")} />
      </MyNavLink>
    </div>
  );
};

export default BottomNav;
